export const defaultFavicon =
  'https://s3.us-east-1.amazonaws.com/cms.public.resources/favicon/default-cms/favicon.ico';
